/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 1.7q.62 0 1.22.11-.34.34-.63.77a.4.4 0 0 0-.02.36q.1.19.32.2c.52 0 .75.1.83.2.19.36 0 .78-.1 1.14-.08.3-.1.66.08.86.14.14.32.16.45.15l-.27.21c-.4.33-.88.79-.99 1.46 0 .46 0 1 .22 1.34.2.3.53.44.83.5.56.1 1.05.06 1.35.26.27.36.45.96.63 1.57.18.63.34 1.28.84 1.66.2.14.52.02.56-.22.08-.38.21-.58.4-.83.54-.64.72-1.37 1.22-2.05q.15-.21.34-.35a7.28 7.28 0 1 1-14.4-1.55c.36.23.47.72.55 1.06q.03.1.1.17c.84.84 1.14 1.6 1.14 2.6q0 .13.08.22c.48.58 1.05 1.02 1.48 1.55.43.54.75 1.15.75 2.14 0 .14.1.28.24.33l.53.18c.16.05.36-.03.43-.18a5 5 0 0 1 1.6-3.11c.48-.5.93-1.04.93-2.02 0-.16-.12-.31-.27-.35-.57-.14-1.1-.69-1.83-1.08-.68-.37-1.6-.48-2.78.1-.12-.16-.1-.43-.1-.63a.4.4 0 0 0-.15-.3q-.35-.24-.48-.43c.16.05.34-.03.42-.18.4-.8 1.13-1.33 1.87-1.8.74-.45 1.48-.76 1.85-1.38.15-.5 0-1.1-.16-1.5a9 9 0 0 0-.54-1.02Q8.24 1.7 9 1.7",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 1A8 8 0 1 0 9 17.01 8 8 0 0 0 9 1Z",
                stroke: "currentColor",
                strokeWidth: 2,
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
